export default "__VITE_ASSET__DH$6RrKc__"